import { useEffect } from 'react';

export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = `istanbulTANGO - ${title}`;
    return () => { document.title = 'istanbulTANGO Portal'; };
  }, [title]);
}
